import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

// import ModalApproveSfa from "./sfaComponents/ModalApproveSfa";
import { CircularProgress } from "@mui/material";
import { ImInsertTemplate } from "react-icons/im";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";
import ModalApprovalPbf from "./ModalApprovalPbf";
import { getDetailApprovalPbf } from "../../../services/approvalApi";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const DetailApprovalPbf = () => {
  const { id } = useParams();

  const [openActionModal, setOpenActionModal] = useState(false);
  const [action, setAction] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const {
    data: dataDetail,
    isFetching: isFetchingDetail,
    refetch: refetchDetail,
    error,
  } = useQuery({
    queryKey: ["detail-sfa", id],
    queryFn: () => getDetailApprovalPbf(id),
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (error)
      setErrorMessage(error.message?.id ? error.message?.id : error.message);
  }, [error]);

  return (
    <div className="text-[12px]">
      <div className="lg:flex gap-2 items-start mb-4">
        <div className="w-full">
          <div className="flex gap-2 items-center w-full mb-4">
            <div className="w-full">
              <p className="font-semibold">Tanggal Order</p>
              {dataDetail && !isFetchingDetail ? (
                <p>
                  {moment(dataDetail.approval?.order_date).format(
                    "DD MMMM YYYY",
                  )}
                </p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
            <div className="w-full">
              <p className="font-semibold">Jam Order</p>
              {dataDetail && !isFetchingDetail ? (
                <p>{moment(dataDetail.approval?.order_date).format("HH:mm")}</p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
          </div>
          <div className="flex gap-2 items-center w-full mb-4">
            <div className="w-full">
              <p className="font-semibold">No Faktur</p>
              {dataDetail && !isFetchingDetail ? (
                <p>{dataDetail.approval?.invoice_no}</p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
            <div className="w-full">
              <p className="font-semibold">No SP/PO</p>
              {dataDetail && !isFetchingDetail ? (
                <p>{dataDetail.approval?.po_number?.split(":")[1]}</p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
          </div>
          <div className="flex gap-2 items-center w-full mb-4">
            {dataDetail &&
            (dataDetail.approval.approval_status === "approved" ||
              dataDetail.approval.approval_status === "rejected") ? (
              <div className="w-full">
                <p className="font-semibold">Status</p>
                {dataDetail && !isFetchingDetail ? (
                  <p
                    className={`${
                      dataDetail.approval.approval_status === "approved"
                        ? "text-green-500"
                        : "text-red-500"
                    }`}
                  >
                    {dataDetail.approval.approval_status === "approved"
                      ? "Diterima"
                      : "Ditolak"}
                  </p>
                ) : isFetchingDetail ? (
                  <CircularProgress size={10} />
                ) : (
                  "-"
                )}
              </div>
            ) : null}
          </div>
        </div>
        {dataDetail &&
        dataDetail.approval.approval_status === "pending" &&
        !isFetchingDetail ? (
          <div className="lg:basis-2/3 flex gap-2 items-center w-full">
            <button
              className="w-full border-2 rounded-md p-2 border-red-500 text-red-500 hover:bg-red-100 disabled:bg-gray-300 disabled:border-none disabled:text-white"
              // disabled={!isValidChange(true)}
              onClick={() => {
                setAction(2);
                setOpenActionModal(true);
              }}
            >
              Tolak
            </button>
            <button
              className="w-full border-2 rounded-md p-2 border-blue-500 bg-blue-500 text-white hover:bg-gray-300 disabled:bg-gray-300 disabled:border-gray-300"
              // disabled={!isValidChange(false)}
              onClick={() => {
                setAction(1);
                setOpenActionModal(true);
              }}
            >
              Terima
            </button>
          </div>
        ) : null}
      </div>

      <div className="mb-4">
        <p className="text-[14px] font-semibold border-b-2 pb-2">
          Informasi Produk
        </p>
        <div>
          {dataDetail && !isFetchingDetail ? (
            dataDetail.invoice.items?.map((item, i) => (
              <div
                key={i}
                className="border-b-2 flex items-center justify-between gap-8 py-2"
              >
                <div>
                  <p className="mb-2 text-[14px]">{item.name}</p>
                  <p>
                    {item.qty} x {toIDR(item.unit_price)}
                  </p>
                </div>
                <p className="font-semibold text-[14px]">
                  {toIDR(item.line_total)}
                </p>
              </div>
            ))
          ) : isFetchingDetail ? (
            <CircularProgress size={20} sx={{ marginTop: 2 }} />
          ) : null}
        </div>
      </div>

      <p className="text-[14px] font-semibold mb-2">Rincian Pembayaran</p>
      {dataDetail && !isFetchingDetail ? (
        <div>
          <div className="flex justify-between items-center font-semibold">
            <p>Produk</p>
            <p>Subtotal</p>
          </div>
          <hr className="my-2" />
          <div className="flex justify-between items-center mb-2">
            <p>Metode Pembayaran</p>
            <p>{dataDetail.invoice.header.payment_method_name}</p>
          </div>
          <div className="flex justify-between items-center mb-2">
            <p>
              Total harga ( {dataDetail.invoice.header.items?.length} produk)
            </p>
            <p>{toIDR(dataDetail.invoice.payment_summary.subtotal)}</p>
          </div>
          <div className="flex justify-between items-center mb-2">
            <p>Biaya pengiriman</p>
            <p>Gratis</p>
          </div>
          <div className="flex justify-between items-center mb-2">
            <p>Pajak (PPN 11%)</p>
            <p>{toIDR(dataDetail.invoice.payment_summary.ppn_amount)}</p>
          </div>
          <div className="flex justify-between items-center mb-2">
            <p>Biaya admin</p>
            <p>{toIDR(dataDetail.invoice.payment_summary.payment_fee)}</p>
          </div>
          {dataDetail.invoice.payment_summary.voucher_amount &&
          dataDetail.invoice.payment_summary.voucher_amount > 0 ? (
            <div className="flex justify-between items-center mb-2">
              <p>Promo</p>
              <p>-{toIDR(dataDetail.invoice.payment_summary.voucher_amount)}</p>
            </div>
          ) : null}
          {dataDetail.invoice.payment_summary.loyalty_point_used &&
          dataDetail.invoice.payment_summary.loyalty_point_used > 0 ? (
            <div className="p-2 rounded-md bg-yellow-100 text-amber-500 flex justify-between items-center mb-2">
              <div>
                <p className="font-semibold">Olin Point</p>
                <p>Dari transaksi pembelian</p>
              </div>
              <p>
                {toIDR(dataDetail.invoice.payment_summary.loyalty_point_used)}
              </p>
            </div>
          ) : null}
          <hr className="mb-2" />
          <div className="flex justify-between items-center mb-4 font-semibold">
            <p>Total</p>
            <p>{toIDR(dataDetail.invoice.payment_summary.grand_total)}</p>
          </div>
        </div>
      ) : isFetchingDetail ? (
        <CircularProgress size={20} sx={{ marginTop: 2 }} />
      ) : null}

      {dataDetail && action ? (
        <ModalApprovalPbf
          open={openActionModal && action}
          setOpen={setOpenActionModal}
          selectedRequest={{
            uid: [dataDetail.approval.invoice_uid],
            invNum: [dataDetail.approval.invoice_no],
            action: action,
          }}
          onSuccessFunc={() => {
            setAction(null);
            refetchDetail();
          }}
        />
      ) : null}

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default DetailApprovalPbf;
